<template>
  <div class="account-admin container">
    <div class="row mb-2">
      <div class="col-12 col-md-9">
        <h1>
          Crisis Services
        </h1>
      </div>
      <div class="col-12">
        <hr />
      </div>
      <div class="col-12 mb-30">
        <div class="btn-group" role="group">
          <button type="button" :class="activeView === 'overview' ? 'btn active' : 'btn btn-secondary'" @click="setActiveView('overview')">
            Overview
          </button>
          <button type="button" :class="activeView === 'crisis-cases' ? 'btn active' : 'btn btn-secondary'" @click="setActiveView('crisis-cases')">
            Cases
          </button>
        </div>
      </div>
      <div v-if="!aggregateData" class="col-12">
        <Loader />
      </div>
      <div v-if="activeView === 'overview' && aggregateData" class="col-12">
        <form-component>
          <b-row class="filters">
            <b-col sm="12" lg="2">
              <input-datepicker
                id="from"
                v-model="from"
                name="from"
                label="From"
                type="text"
              />
            </b-col>
            <b-col sm="12" lg="2">
              <input-datepicker
                id="through"
                v-model="through"
                name="through"
                label="Through"
                type="text"
              />
            </b-col>
            <b-col class="mb-3" offset-lg="4" offset-sm="0" sm="12" lg="4">
              <campus-drop-down
                :value="selectedInstitution"
                @input="selectedInstitution=$event"
              />
            </b-col>
          </b-row>
        </form-component>
        <div class="row row-eq-height">
          <div class="col-12 col-md-5">
            <crisis-calls-by-presenting-issue :data="aggregateData.byIssue" />
          </div>
          <div class="col-12 col-md-5">
            <crisis-calls-by-time-of-day :data="aggregateData.byHourOfDay" />
          </div>
          <div class="col-12 col-md-2 crisis-aggregate">
            <div class="dashboard-card stat text-center">
              <h2>{{ aggregateData.totalCalls }}</h2>
              <label>Total Calls</label>
            </div>
          </div>
        </div>
        <div v-if="aggregateData" class="row row-eq-height">
          <div class="col-12 col-md-5">
            <crisis-calls-by-day-of-week :data="aggregateData.byDayOfWeek" />
          </div>
          <div class="col-12 col-md-5">
            <crisis-calls-by-month :data="aggregateData.byMonthAndYear" />
          </div>
        </div>
      </div>
      <div v-if="activeView === 'crisis-cases'" class="col-12">
        <crisis-cases-table />
      </div>
    </div>
  </div>
</template>

<script>

import CrisisCasesTable from './components/CrisisCasesTable/CrisisCasesTable.vue';
import Loader from '@/components/Loader.vue';
import InputDatepicker from '@/components/inputs/InputDatepicker.vue';
import FormComponent from '@/components/FormComponent.vue';
import CrisisClient from '@/api/ClinicalOps/CrisisClient';
import CrisisCallsByPresentingIssue from './components/CrisisCallsByPresentingIssue.vue';
import CrisisCallsByDayOfWeek from './components/CrisisCallsByDayOfWeek.vue';
import CrisisCallsByTimeOfDay from './components/CrisisCallsByTimeOfDay.vue';
import CrisisCallsByMonth from './components/CrisisCallsByMonth.vue';
import CampusDropDown from './components/CampusDropDown.vue';
import moment from 'moment';


export default {
  name: 'CrisisServices',
  components: {
    CrisisCasesTable,
    InputDatepicker,
    FormComponent,
    CampusDropDown,
    Loader,
    CrisisCallsByPresentingIssue,
    CrisisCallsByDayOfWeek,
    CrisisCallsByTimeOfDay,
    CrisisCallsByMonth
  },

  data() {
    return {
      crisisClient: new CrisisClient(this.$http),
      aggregateData: null,
      activeView: 'overview',
      from: '',
      through: '',
      selectedIssues: [],
      institutions: [],
      selectedInstitution: 0,
      totalFilteredCalls: 0,
    }
  },
  watch: {
    from() {
      this.loadData();
    },
    through() {
      this.loadData();
    },
    selectedInstitution() {
      this.loadData();
    }
  },
  async mounted() {
    await this.loadData();
  },
  methods: {
    setActiveView(selection) {
      this.activeView = selection;
    },
    async loadData() {
      const response = await this.crisisClient.getCrisisCasesAggregates(
        null,
        this.selectedInstitution === 0 ? null : this.selectedInstitution,
        this.from ? moment(this.from).startOf('day').toISOString() : undefined,
        this.through ? moment(this.through).endOf('day').toISOString() : undefined,
      );

      this.aggregateData = response;
    }
  }
}
</script>

<style lang="scss" scoped>
.filters {
  background-color: $dark-blue;
  margin-bottom: 10px;
  margin-right: 0px;
  margin-left: 0px;
  padding-top: 5px;
  @include border-radius($border-radius);
}

.btn-group {
  margin-top: 8px;

    @media (max-width: $sm-max) {
      width: 100%;
    }

    .btn {
      @include border-radius($border-radius);

      background: rgba(255, 255, 255, 0.25);
      color: $white;
      margin-right: 5px;
      font-weight: normal;
      outline: 0;
      box-shadow: none;

      @media (min-width: $xl-min) {
        min-width: 120px;
      }

      &:not(:last-child) {
        border-radius: 5px;
      }

      &.last {
        margin-right: 0;
      }

      &.active {
        background-color: $white;
        color: rgba(0, 0, 0, 0.76);
      }

      @media (max-width: $sm-max) {
        width: 25%;
      }
    }
}

.crisis-aggregate {
  .stat {
      padding: 25px 30px;
      @include blue-gradient;
      label {
        @include label;

        display: inline-block;
        color: $green;
        margin-bottom: -5px;
      }

      h2 {
        font-size: 60px;
        margin-top: -5px;
      }
    }
    .row-eq-height {
      .dashboard-card {
        height: calc(100% - 20px);
      }
    }
}

</style>
